<template>
  <div class="news-view">
    <div class="news-list">
      <NewsTeaser :news="news" v-for="news in newsList" v-if="newsList" :key="news.id"/>
    </div>
    <div class="news-list">
      <button v-on:click="moreNews" v-if="hasNextPage" class="button-white leggi-tutto">Carica altre news</button>
    </div>
  </div>
</template>

<script>
  import NewsTeaser from '@/components/elements/NewsTeaser.vue';
  import Waterwheel from "waterwheel"
  import jsonapiParse from "jsonapi-parse"

  const waterwheel = new Waterwheel(
      {
        base: process.env.VUE_APP_HOST_URL,
        jsonapiPrefix: 'api',
        timeout: 3000,
        accessCheck: false
      }
  );
  let query = {
    filter: {
      status: 1
    },
    include: 'featured_image, documents',
    sort: '-data',
    page: { limit: 3},
  }

  export default {
    name: 'NewsList',
    metaInfo: {
      title: 'News',
      titleTemplate: '%s - Gabiano Holding',
    },
    data() {
      return {
        loading: true,
        page: [],
        title: '',
        modules: [],
        newsList: [],
        limit: 3,
        hasNextPage: ''
      }
    },
    created() {
      // Load News.
      waterwheel.jsonapi.get('node/news', query).then(news => {
        this.newsList = jsonapiParse.parse(news).data;
        this.hasNextPage = news.links.hasOwnProperty("next");
      })
    },
    methods: {
      moreNews() {
        this.limit = this.limit +3
        query.page.limit = this.limit
        waterwheel.jsonapi.get('node/news', query).then(news => {
          this.newsList = jsonapiParse.parse(news).data;
          this.hasNextPage = news.links.hasOwnProperty("next");
        })
      },
    },
    components: {
      NewsTeaser,
    }
  }

</script>
